"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDotCountMaxOverflow = exports.MAX_OVERFLOW_COUNT = void 0;
// If a badge count is greater than max (optional, defaults at 99), it should
// truncate the numbers so its x+.
const MAX_OVERFLOW_COUNT = 99;
exports.MAX_OVERFLOW_COUNT = MAX_OVERFLOW_COUNT;
const parseDotCountMaxOverflow = (count, max = MAX_OVERFLOW_COUNT) => {
  return count <= max ? count : `${max}+`;
};
exports.parseDotCountMaxOverflow = parseDotCountMaxOverflow;